import React from "react";

export function repoName(repo_url) {
    if (repo_url.startsWith('https://github.com/'))
      return repo_url.replace('https://github.com/', '')
    return repo_url;
}

export function ciIcon(project_name, ci_system) {
  if (ci_system === "travis-ci")
    return (<a href={"https://travis-ci.org/" + project_name}><img alt="travis-ci" src="https://cdn.travis-ci.com/images/logos/TravisCI-Mascot-grey.png" width="12" height="12"></img></a>);
  if (ci_system === "circleci")
    return (<a href={"https://circleci.com/gh/" + project_name}><img alt="circleci" src="/img/logo-badge-grey.svg" width="12" height="12"></img></a>);
  return (<i>{ci_system}</i>);
}

export function buildLink(repo_url, ci_name, ci_job) {
  if (ci_name === "travis-ci") {
    return "https://travis-ci.org/" + repoName(repo_url) + "/jobs/" + ci_job;
  }
  console.log("Unknown ci system: " + ci_name);
  return "#";
}




// WEBPACK FOOTER //
// ./src/helpers/helpers.js